module.exports = __webpack_public_path__ + "static/media/error.4639de75.png";